import profile from "../views/profile/index.vue";

const routes = [
  {
    path: "/profile",
    name: "profile",
    component: profile,
    meta: { authOnly: true },
  },
  
];

export default routes;